export const LATEST_PRIVACY_POLICY = 1;
export const LATEST_DATA_PROCESSING_AGREEMENT = 1;
export const LATEST_TERMS_OF_SERVICE = 1;
